<template>
	<div class="header-box" :class="xieyi ? 'header-box1' : ''">
		<div class="header-nav u-flex u-col-center u-row-between">
			<div class="nav-left u-flex u-col-center">
				<div class="u-flex u-col-center"  @click="showmenu = true">
					<img src="../assets/imgs/nav1.png" alt="">
					<span>{{$t('菜单')}}</span>
				</div>
				<div class="u-flex u-col-center"  @click="showxilie = true">
					<img src="../assets/imgs/nav5.png" alt="" style="margin-left: 20px">
					<span>{{$t('腕表系列')}}</span>
				</div>
			</div>
			<img class="nav-title" src="../assets/imgs/nav6.png" alt="" @click="toindex">
			<div class="nav-right u-flex u-col-center u-row-right">
				<div class="right-item u-flex u-col-center" @click="toindex">
					<span>{{$t('首页')}}</span>
					<img src="../assets/imgs/nav7.png" alt="">
				</div>
				<div class="right-item u-flex u-col-center" @click="opensearch">
					<span>{{$t('搜索')}}</span>
					<img src="../assets/imgs/nav2.png" alt="">
				</div>
				<div class="right-item u-flex u-col-center" @click="showyuyan = true">
					<span v-if="$locale == 'en'">English</span>
					<span v-if="$locale == 'zh'">简体中文</span>
					<span v-if="$locale == 'de'">Deutsch</span>
					<img src="../assets/imgs/nav3.png" alt="">
				</div>
			</div>
		</div>
		<!-- <div class="header-nav u-flex u-col-center u-row-between"  v-if="xieyi">
			<div class="nav-left u-flex u-col-center">
				<div class="u-flex u-col-center"  @click="showmenu = true">
					<img src="../assets/imgs/nav1-1.png" alt="">
					<span style="color: #000">{{$t('菜单')}}</span>
				</div>
				<div class="u-flex u-col-center"  @click="showxilie = true">
					<img src="../assets/imgs/nav5-1.png" alt="" style="margin-left: 20px">
					<span style="color: #000">{{$t('腕表系列')}}</span>
				</div>
			</div>
			<img class="nav-title" src="../assets/imgs/nav6-1.png" alt="" @click="toindex">
			<div class="nav-right u-flex u-col-center u-row-right">
				<div class="right-item u-flex u-col-center" @click="opensearch">
					<span style="color: #000">{{$t('搜索')}}</span>
					<img src="../assets/imgs/nav2-1.png" alt="">
				</div>
				<div class="right-item u-flex u-col-center" @click="showyuyan = true">
					<span style="color: #000" v-if="$locale == 'en'">English</span>
					<span style="color: #000" v-if="$locale == 'zh'">简体中文</span>
					<span v-if="$locale == 'de'">Deutsch</span>
					<img src="../assets/imgs/nav3-1.png" alt="">
				</div>
			</div>
		</div> -->
		<!-- <div v-if="$route.meta.name" class="h5-navbar u-flex u-col-center u-row-between">
			<img @click="$router.go(-1)" src="../assets/imgs/h5-back.png" class="h5-back" alt="">
			<span class="h5-title">{{h5title}}</span>
			<span style="color: #fff;font-size: 15px;" @click="toindex()">{{$t('首页')}}</span>
		</div> -->
		<el-drawer :visible.sync="showsearch" :withHeader="false" size="auto" direction="ttb" :modal-append-to-body="false">
			<div class="search-box">
				<div class="search-header u-flex u-col-center u-row-between">
					<img class="img1" src="../assets/imgs/search1-1.png" alt="" srcset="" @click="showsearch = false">
					<img class="img2" src="../assets/imgs/nav6.png" alt="">
					<img class="img1" @click="showsearch = false" src="../assets/imgs/search1-1.png" alt="" srcset="">
				</div>
				<div class="search-title u-flex u-col-center u-row-between">
					<img class="img1" @click="showsearch = false" src="../assets/imgs/search1-1.png" alt="" srcset="">
					<span>{{$t('搜索巴博斯网站')}}</span>
					<img class="img1" src="../assets/imgs/search1-1.png" alt="" srcset="">
				</div>
				<div class="search-input u-flex u-col-center u-row-center">
					<input type="text" :placeholder="$t('搜索')" v-model="keyword" @change="tosearch">
					<!-- <img src="../assets/imgs/search1-2.png" alt="" @click="tosearch"> -->
					<i class="el-icon-right" @click="tosearch"></i>
				</div>
				<div class="search-list" v-if="search_list.length">
					<div class="search-list-item" v-for="list_item in search_list" :key="list_item.id" @click="search_value_click(list_item)">
						<span v-if="$locale == 'zh'">{{list_item.name}}</span>
						<span v-if="$locale == 'en'">{{list_item.nameEnglish}}</span>
						<span v-if="$locale == 'de'">{{list_item.nameGerman}}</span>
					</div>
				</div>
				<div class="notsearch" v-if="shownotdata">
					*{{$t('没有结果，请输入其他关键字')}}
				</div>
			</div>
		</el-drawer>
		<el-drawer :visible.sync="showyuyan" :withHeader="false" size="auto" direction="rtl" :modal-append-to-body="false">
			<div @click="showyuyan = false" class="changeyuyan-box u-flex-col u-col-bottom">
				<div @click.stop class="changeyuyan-header u-flex-col u-col-center u-row-between">
					<div class=" u-flex u-col-center u-row-between" style="width: 100%">
						<div></div>
						<img class="img1" src="../assets/imgs/nav6.png" alt="" srcset="">
						<img class="img1" @click="showyuyan = false" src="../assets/imgs/search1-1.png" alt="" srcset="">
					</div>
					<span>{{$t('切换语言')}}</span>
				</div>
				<div @click.stop class="changeyuyan">
					<div class="yuyan-header u-flex u-col-center u-row-center">
						<span v-if="$locale == 'en'">English</span>
						<span v-if="$locale == 'zh'">简体中文</span>
						<!-- <span v-if="$locale == 'de'">Deutsch</span> -->
						<img src="../assets/imgs/search1-1.png" @click="showyuyan = false" alt="">
					</div>
					<div @click="changeyuyan('en')" :class="$locale == 'en' ? 'yuyan-item yuyan-item1' : 'yuyan-item'">
						English
					</div>
					<div @click="changeyuyan('zh')" :class="$locale == 'zh' ? 'yuyan-item yuyan-item1' : 'yuyan-item'">
						简体中文
					</div>
					<!-- <div @click="changeyuyan('de')" :class="$locale == 'de' ? 'yuyan-item yuyan-item1' : 'yuyan-item'">
						Deutsch
					</div> -->
				</div>
			</div>

		</el-drawer>
		<el-drawer :visible.sync="showmenu" :withHeader="false" size="auto" direction="ltr" :modal-append-to-body="false">
			<div class="menu-box u-flex-col" @click="showmenu = false">
					<!-- <div @click.stop class="menu-header u-flex u-col-center u-row-between">
						<img class="img1" @click="showmenu = false" src="../assets/imgs/search1-1.png" alt="" srcset="">
						<span>{{$t('菜单')}}</span>
						<img class="img1" src="../assets/imgs/search1-1.png" alt="" srcset="">
					</div> -->
				<div class="menu-content u-flex">
					<div @click.stop class="menu-left u-flex-col">
						<div class="left-top">
							<div class="pc-left-top u-flex u-col-center u-row-center" @click="showmenu = false">
								<img src="../assets/imgs/search1-1.png" alt="">
								<!-- <span>{{$t('关闭')}}</span> -->
							</div>
							<!-- <div @click="toopenlabel(1)" class="top-title u-flex u-col-center u-row-between">
								<span :style="{color:open_active == 1 ? '#C40D2E' : '#D7D7D7'}">{{$t('品牌探索')}}</span>
								<i :style="{transform: open_active == 1 ? 'rotate(90deg)' : 'rotate(0deg)',color: open_active == 1 ? '#C40D2E' : '#D7D7D7'}" class="el-icon-arrow-right"></i>
							</div>
							<div class="label-box" v-if="open_active == 1">
								<div :class="open_active == 1 ? 'label-item label-item1' : 'label-item'">
									<span @click="topath('/about')">{{$t('关于品牌')}}</span>
								</div>
								<div :class="open_active == 1 ? 'label-item label-item1' : 'label-item'">
									<span @click="topath('/news')">{{$t('新闻模块')}}</span>
								</div>
							</div>
							<div @click="toopenlabel(2)" class="top-title u-flex u-col-center u-row-between">
								<span :style="{color:open_active == 2 ? '#C40D2E' : '#D7D7D7'}">{{$t('使用与服务')}}</span>
								<i :style="{transform: open_active == 2 ? 'rotate(90deg)' : 'rotate(0deg)',color:open_active == 2 ? '#C40D2E' : '#D7D7D7'}" class="el-icon-arrow-right"></i>
							</div>
							<div class="label-box" v-if="open_active == 2">
								<div :class="open_active == 2 ? 'label-item label-item1' : 'label-item'">
									<span @click="topath('/check')">{{$t('真伪查询服务')}}</span>
								</div>
								<div :class="open_active == 2 ? 'label-item label-item1' : 'label-item'">
									<span @click="topath('/asked')">{{$t('常见问题')}}</span>
								</div>
								<div :class="open_active == 2 ? 'label-item label-item1' : 'label-item'">
									<span @click="topath('contact_us')">{{$t('联系我们')}}</span>
								</div>
							</div>
							<div @click="toopenlabel(3)" class="top-title u-flex u-col-center u-row-between">
								<span :style="{color:open_active == 3 ? '#C40D2E' : '#D7D7D7'}">{{$t('服务政策')}}</span>
								<i :style="{transform: open_active == 3 ? 'rotate(90deg)' : 'rotate(0deg)',color:open_active == 3 ? '#C40D2E' : '#D7D7D7'}" class="el-icon-arrow-right"></i>
							</div>
							<div class="label-box" v-if="open_active == 3">
								<div :class="open_active == 3 ? 'label-item label-item1' : 'label-item'">
									<span @click="topath('/xieyi?type=1')">{{$t('服务条款')}}</span>
								</div>
								<div :class="open_active == 3 ? 'label-item label-item1' : 'label-item'">
									<span @click="topath('/xieyi?type=2')">{{$t('隐私政策')}}</span>
								</div>
							</div> -->

							<div class="top-title u-flex u-col-center u-row-between fadeToRight animated-1">
								<span style="color:#D7D7D7">{{$t('品牌探索')}}</span>
								<i style="transform:rotate(0deg);color: #D7D7D7" class="el-icon-arrow-right"></i>
							</div>
							<div class="label-box" >
								<div class="label-item label-item1 fadeToRight animated-2">
									<span @click="topath('/about')">{{$t('关于品牌')}}</span>
								</div>
								<div class="label-item label-item1 fadeToRight animated-3">
									<span @click="topath('/news')">{{$t('新闻模块')}}</span>
								</div>
							</div>
							<div class="top-title u-flex u-col-center u-row-between fadeToRight animated-1">
								<span style="color:#D7D7D7">{{$t('使用与服务')}}</span>
								<i style="transform:rotate(0deg);color: #D7D7D7" class="el-icon-arrow-right"></i>
							</div>
							<div class="label-box" >
								<div class="label-item label-item1 fadeToRight animated-2">
									<span @click="topath('/check')">{{$t('真伪查询服务')}}</span>
								</div>
								<div class="label-item label-item1 fadeToRight animated-3">
									<span @click="topath('/asked')">{{$t('常见问题')}}</span>
								</div>
								<div class="label-item label-item1 fadeToRight animated-4">
									<span @click="topath('contact_us')">{{$t('联系我们')}}</span>
								</div>
							</div>
							<div class="top-title u-flex u-col-center u-row-between fadeToRight animated-1">
								<span style="color:#D7D7D7">{{$t('服务政策')}}</span>
								<i style="transform:rotate(0deg);color: #D7D7D7" class="el-icon-arrow-right"></i>
							</div>
							<div class="label-box" >
								<div class="label-item label-item1 fadeToRight animated-2">
									<span @click="topath('/xieyi?type=1')">{{$t('服务条款')}}</span>
								</div>
								<div class="label-item label-item1 fadeToRight animated-3">
									<span @click="topath('/xieyi?type=2')">{{$t('隐私政策')}}</span>
								</div>
							</div>

							<!-- <div @click="openlabel = !openlabel" class="top-title u-flex u-col-center u-row-between">
								<span :style="{color:openlabel ? '#3FB56F' : '#D7D7D7'}">{{$t('手表系列')}}</span>
								<i :style="{transform: openlabel ? 'rotate(90deg)' : 'rotate(0deg)'}" class="el-icon-arrow-right"></i>
							</div>
							<div class="label-box">
								<div :class="openlabel ? 'label-item label-item1' : 'label-item'" v-for="(item,index) in labellist" :key="index" @click="open(item)">
									<span v-if="$locale == 'zh'">{{item.name}}</span>
									<span v-if="$locale == 'en'">{{item.nameEnglish}}</span>
									<span v-if="$locale == 'de'">{{item.nameGerman}}</span>
								</div>
							</div>
							<div class="menu-item" @click="toabout">
								{{$t('关于品牌')}}
							</div>
							<div class="menu-item" @click="tonews">
								{{$t('新闻模块')}}
							</div>
							<div class="menu-item" @click="tocheck">
								{{$t('防伪检测')}}
							</div> -->
						</div>
						<div class="left-down u-flex-col u-col-center">
							<span class="span1">{{$t('关注巴博斯')}}</span>
							<span class="span1">{{$t('成为我们的一员')}}</span>
							<img :src="code" alt="">
							<div class="u-flex u-col-center u-row-center">
								<img src="../assets/imgs/wx.png" style="width: 12px;height: 12px;margin: 0;" alt="">
								<span class="span2">{{$t('打开微信并扫码')}}</span>
							</div>
						</div>
					</div>
					<div @click.stop class="menu-right" :style="{width:opencchild ? '74%' : '0',padding:opencchild ? '4px' : '0'}">
						<div class="menu-right-title">
							{{labeltitle}}
						</div>
						<div class="pc-padding">
							<div class="biao-item u-flex-col u-col-center" v-for="(item,index) in goodslist" :key="index" @click="toinfo(item)">
								<img :src="item.pic" alt="">
								<span class="span1" v-if="$locale == 'zh'">{{item.name}}</span>
								<span class="span1" v-if="$locale == 'en'">{{item.nameEnglish}}</span>
								<span class="span1" v-if="$locale == 'de'">{{item.nameGerman}}</span>
								<span class="span2">{{item.modelNumber}}</span>
							</div>
						</div>
						<el-empty :description="$t('暂无数据')" v-if="goodslist.length == 0"></el-empty>
						<div class="u-flex u-col-center u-row-center" style="width: 100%;">
							<div class="down-more u-flex u-col-center u-row-center" @click="tolist">
								<img src="../assets/imgs/menu1-1.png" alt="">
								<span>{{$t('全部手表')}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</el-drawer>
		<el-drawer :visible.sync="showxilie" :with-header="false" size="auto" direction="ttb" :modal-append-to-body="false">
			<div class="xilie-box u-flex u-col-center u-row-center" @mouseleave="showxilie = false">
			<!-- <div class="xilie-box u-flex u-col-center u-row-center"> -->
				<div class="u-flex u-col-center u-row-center xilie-list">
					<div class="swiper-button-prev u-flex u-col-center u-row-center" @click="toprev">
						<i class="el-icon-arrow-left	"></i>
					</div>
					<div class="swiper-container" ref="wrapper">
						<div class="swiper-top u-flex u-col-center u-row-between">
							<div class="top-left u-flex u-col-flex" @click="showxilie = false">
								<i class="el-icon-arrow-left"></i>
								<span>{{$t('返回')}}</span>
							</div>
							<img src="../assets/imgs/nav6.png" alt="" @click="toindex">
							<div></div>
						</div>
						<div class="swiper-wrapper" id="wrapper">
							<div class="swiper-slide u-flex-col u-col-center" v-for="(item,index) in labellist" :key="index" @click="toinfo(item)">
								<div style="position: relative">
									<img class="img1" :src="item.pic" alt="" style="transform:unset;">
									<img class="img2" :src="item.pic2 ? item.pic2 : item.pic1" alt="" style="transform:unset;">
								</div>
								<span class="title">{{item.seriesName}}</span>
								<span class="title" v-if="$locale == 'en'">{{ item.nameEnglish }}</span>
								<span class="title" v-if="$locale == 'zh'">{{ item.name }}</span>
								<button class="item-btn">{{ $t('探索') }}</button>
							</div>
						</div>
						<!-- <div class="back u-flex u-col-center u-row-between" @click="showxilie = false">
							<i class="el-icon-arrow-left"></i>
							<span>{{ $t('返回首页') }}</span>
						</div> -->
					</div>
					<div class="swiper-button-next u-flex u-col-center u-row-center" @click="tonext">
						<i class="el-icon-arrow-right	"></i>
					</div>
				</div>
				<div class="swiper-pagination u-flex u-col-center u-row-center">
					<span class="banner-img" :class="active == 0 ? 'banner-img-active' : ''" style="margin: 0 15px;" @click="toprev"></span>
					<span class="banner-img" :class="active == 1 ? 'banner-img-active' : ''" style="margin: 0 15px;" @click="tonext"></span>
				</div>
			</div>
		</el-drawer>
	</div>

</template>

<script>
	import {
		has
	} from 'core-js/library/fn/dict'
	export default {
		props: {
			xieyi: {
				typeof: Boolean,
				default: false
			},
		},
		data() {
			return {
				// 搜索
				showsearch: false,
				// 搜索列表
				search_list: [],
				// 搜索状态
				search_loading: false,
				// 语言
				showyuyan: false,
				// 菜单
				showmenu: false,
				// 菜单分类
				openlabel: false,
				open_active: 0,
				// 商品
				opencchild: false,
				// 腕表系列
				showxilie: false,
				// 分类列表
				labellist: [],
				// h5标题
				h5title: '',
				// 商品列表
				goodslist: [],
				// 当前分类标题
				labeltitle: '',
				// 关键字搜索
				keyword: '',
				// 是否显示暂无数据
				shownotdata:false,
				// 判断上滑还是下滑
				nowscrollltop:0,
				active: 0,
				timer: null,
				code: '',
			}
		},
		created() {
			this.getlabel()
			this.getcode()
		},
		watch: {
			$route() {
				if (!this.$route.meta.name) {
					this.h5title = ''
				}
			},
			keyword(val){
				if(!val) return this.search_list = [];
				this.search_value_change(val)
			}
		},
		mounted() {
			window.onscroll = (e) => {
				var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
				if(scrollTop == 0){
					$(".header-box").css('background','rgba(0,0,0,0)')
				}else{
					$(".header-box").css('background','rgba(0,0,0,0.1)')
				}
				if(this.nowscrollltop == 0){
					this.nowscrollltop = scrollTop
				}else{
					if(this.nowscrollltop > scrollTop){
						// 上滑
						$(".header-box").css('top','0')
					}else{
						// 下滑
						$(".header-box").css('top','-89px')
					}
					this.nowscrollltop = scrollTop
				}
			}
		},
		computed: {
			
		},
		methods: {
			getcode() {
				this.$http.post('/api/Index/indexInfo').then((res) => {
					this.code = res.result.wechatQrCode
				})
			},
			toprev() {
				if(this.active == 0) {
					return
				}
				this.active = 0
				this.stopScroll();
				this.timer = setInterval(() => {
					this.$refs.wrapper.scrollLeft -= 150;
				}, 100);
			},
			tonext() {
				if(this.active == 1) {
					return
				}
				this.active = 1
				this.stopScroll();
				this.timer = setInterval(() => {
					this.$refs.wrapper.scrollLeft += 150;
				}, 100);
			},
			stopScroll() {
				clearInterval(this.timer);
			},
			topath(url) {
				this.showmenu = false
				if(this.$route.path == '/xieyi' && url.indexOf('type') != -1) {
					this.$router.push(url)
					location.reload()
				} else {
					this.$router.push(url)
				}
			},
			toinfo(item) {
				this.showxilie = false
				if(this.$route.path == '/list') {
					this.$router.push({ path: '/list',query: {id: item.id} }); 
					location.reload()
				} else {
					this.$router.push({
						path: "/list",
						query: {
							id: item.id
						}
					})
				}
			},
			toopenlabel(index) {
				if(this.open_active == index) {
					this.open_active = 0
				} else {
					this.open_active = index
				}
			},
			toindex(){
				this.$router.push({
					path:"/"
				})
			},
			changeyuyan(str){
				if(this.$locale == str){
					this.$message.error(this.$t('当前为该语言无需切换'))
					return
				}
				this.$i18n.locale = str
				window.localStorage.locale = str
				this.$router.go()
			},
			tosearch() {
				if (!this.keyword) {
					this.$message.error(this.$t('请输入关键字'))
					return
				}

				this.$http.get('/api/Index/queryCommpdity?name=' + (this.$locale == 'zh' ? this.keyword : '') + '&nameEnglish=' + (this.$locale == 'en' ? this.keyword : '')).then(res => {
					if (res.result[0]) {
						this.shownotdata = false
						this.showsearch = false
						this.$router.push({
							path:"/info",
							query:{
								id:res.result[0].id
							}
						})
						this.search_list = [];
				    this.keyword = '';
					} else {
						this.shownotdata = true
					}
				})
			},
			search_value_change(val) {
				if (this.search_loading) return;
				this.search_loading = true;
				setTimeout(() => {
					this.search_loading = false;
				},1000)
				this.$http.get('/api/Index/queryCommpdity?name=' + (this.$locale == 'zh' ? val : '') + '&nameEnglish=' + (this.$locale == 'en' ? val : '')).then(res => {
					this.search_list = res.result;
				})
			},
			search_value_click(item) {
				if (this.$route.path == '/info') {
					if (this.$route.query.id == item.id) return;
					location.href = location.href.replace(this.$route.query.id,item.id);
					history.go(0)
				} else {
					this.$router.push({
						path:"/info",
						query:{
							id:item.id
						}
					})
				}
				this.search_list = [];
				this.keyword = '';
			},
		/* 	toinfo(item) {
				this.showmenu = false
				this.$router.push({
					path: '/info',
					query: {
						id: item.id
					}
				})
			}, */
			open(item) {
				this.$http.post('/api/Index/getCommpdityList', {
					flId: item.id
				}, true).then(res => {
					if (this.$locale == 'zh') {
						this.labeltitle = item.name
					}
					if (this.$locale == 'en') {
						this.labeltitle = item.nameEnglish
					}
					if (this.$locale == 'de') {
						this.labeltitle = item.nameGerman
					}
					this.opencchild = true
					this.goodslist = res.result
				})

			},
			settitle(title) {
				this.h5title = title
			},
			getlabel() {
				this.$http.post('/api/Index/gety').then(res => {
					this.labellist = res.result
				})
			},
			tolist() {
				this.showmenu = false
				this.$router.push({
					path: "/list"
				})
			},
			tonews() {
				this.showmenu = false
				this.$router.push({
					path: "/news"
				})
			},
			toabout() {
				this.showmenu = false
				this.$router.push({
					path: "/about"
				})
			},
			opensearch() {
				this.showsearch = true
			},
			tocheck() {
				this.showmenu = false
				this.$router.push({
					path: "/check"
				})
			}
		}
	}
</script>

<style lang="scss">
	.header-box1 {
		background: rgba(255,255,255,1);
		border-bottom: 1px solid rgba(0, 0, 0, 0.20);
	} 
	.header-box {
		width: 100%;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 1000;

		// background-color: #000;
		.nav-left {
			width: 30%;
		}

		.nav-right {
			width: 30%;
		}
	}
</style>
<style lang="scss" scoped>
.animated-1 {
	-webkit-animation-duration: 1s;
	animation-duration: 1s;
	-webkit-animation-fill-mode: both;
	animation-fill-mode: both;
}
.animated-2 {
	-webkit-animation-duration: 1.2s;
	animation-duration: 1.2s;
	-webkit-animation-fill-mode: both;
	animation-fill-mode: both;
}
.animated-3 {
	-webkit-animation-duration: 1.4s;
	animation-duration: 1.4s;
	-webkit-animation-fill-mode: both;
	animation-fill-mode: both;
}
.animated-4 {
	-webkit-animation-duration: 1.6s;
	animation-duration: 1.6s;
	-webkit-animation-fill-mode: both;
	animation-fill-mode: both;
}
.fadeToRight {
	-webkit-animation-name: fadeToRight;
	animation-name: fadeToRight;
	visibility: visible;
}
@keyframes fadeToRight {
	0% {
		opacity: 0;
		-webkit-transform: translate3d(-100%,0,0);
		transform: translate3d(-100%,0,0);
	}
	100% {
		opacity: 1;
		-webkit-transform: none;
		transform: none;
	}
}

.search-list {
	border-top: 1px solid rgba(255,255,255,.14);
	margin: 10px auto 0;
	padding-top: 10px;
  max-width: 1009px;
  width: 90%;
	.search-list-item {
		&:hover{
			opacity: .7;
		}
		> span {
			color: #fff;
			font-size: 18px;
			margin-bottom: 10px;
	  }
  }
}
</style>
